import FaqRoute from "./faq";

// Guidelines is a faq alias
export default class GuidelinesRoute extends FaqRoute {
  pageId = "guidelines";
}
